import React from "react";
import { useFormik } from "formik";

import { ITemp } from "../users-table";
import endpoints from "../../../../api/endpoints";
import { swrKeyMatchesAllpanelDownlineList } from "../../../../api/swr-revalidate";
import usePutApi from "../../../../hooks/use-put-api";
import parseNumber from "../../../../utils/parse-number";
import { showErrorToast, showSuccessToast } from "src/utils/toast";
import { useSyncGlobalPageLoader } from "../../../../contexts/global-page-loader-context";
import CreditLimitSchema, { ICreditLimitSchema } from "./schema/credit-limit.schema";

interface Props {
  openModal: boolean;
  toggleModal: () => void;
  rowData: ITemp;
  parentUserId: string;
}

const CreditLimitModal: React.FC<Props> = ({ openModal, toggleModal, rowData, parentUserId }) => {

  const { values, errors, handleChange, handleSubmit, handleBlur, resetForm } = useFormik({
    initialValues: {
      new_credit: 0,
      transaction_password: "",
      member_operation_type: "credit",
    },
    onSubmit: (formValues) => {
      handleCreditLimitSubmit(formValues);
    },
    validationSchema: CreditLimitSchema,
  });

  const { putData, loading: putLoading } = usePutApi(endpoints.member.operation(rowData.id), [
    endpoints.member.getMember(parentUserId),
    swrKeyMatchesAllpanelDownlineList(parentUserId),
  ]);

  useSyncGlobalPageLoader(putLoading);

  const handleCreditLimitSubmit = async (submitData: ICreditLimitSchema) => {
    try {
      await putData({
        ...submitData,
        new_credit: parseNumber({ type: "float", value: values.new_credit }),
      });
      showSuccessToast("Successfully credit updated");
      toggleModal();
      resetForm();
    } catch (error: any) {
      const errorMessage = error?.data?.status_message;
      showErrorToast(errorMessage || "Someting Went Wrong");
      toggleModal();
      resetForm();
    }
  };

  if (!openModal) return null;

  return (
    <>
    {/* style={{ position: "absolute", zIndex: 1040 }} */}
      <div
        role="dialog"
        className="modal fade show"
        aria-modal="true"
        style={{ display: "block" }}
        onMouseDown={(event) => {
          if (event.target === event.currentTarget) {
            toggleModal();
          }
        }}
      >
        <div className="modal-dialog modal-md">
          <span />
          <div className="modal-content" style={{ marginTop: "60px" }}>
            <header className="modal-header">
              <h5 className="modal-title">Credit</h5>
              <button type="button" data-dismiss="modal" className="close text-white" onClick={toggleModal}>
                &times;
              </button>
            </header>
            <div className="modal-body credit-mdl">
              <form method="post" onSubmit={handleSubmit}>
                <div className="form-group row">
                  <label className="col-form-label col-4" htmlFor="creditOldLimit">Old Credit</label>
                  <div className="col-8">
                    <input
                      id="creditOldLimit"
                      placeholder="Old Credit"
                      type="text"
                      readOnly
                      value={rowData.credit_reference}
                      name="userCreditUpdateusrnameamount"
                      className="form-control txt-right"
                    />
                  </div>
                </div>

                <div className="form-group row">
                  <label className="col-form-label col-4" htmlFor="creditNewLimit">New Credit</label>
                  <div className="col-8 form-group-feedback form-group-feedback-right">
                    <input
                      id="creditNewLimit"
                      type="text"
                      name="new_credit"
                      className={`form-control txt-right ${errors.new_credit ? "is-invalid" : ""}`}
                      value={values.new_credit !== 0 ? values.new_credit : ""}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                  </div>
                </div>

                <div className="form-group row">
                  <label className="col-form-label col-4" htmlFor="creditTransactionPassword">Transaction Password</label>
                  <div className="col-8 form-group-feedback form-group-feedback-right">
                    <input
                      id="creditTransactionPassword"
                      name="transaction_password"
                      type="password"
                      className={`form-control ${errors.transaction_password ? "is-invalid" : ""}`}
                      value={values.transaction_password}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                  </div>
                </div>

                <div className="form-group row">
                  <div className="col-12 text-right">
                    <button type="button" className="btn btn-back" onClick={toggleModal}>
                      <i className="fas fa-undo mr-1" />
                      Back
                    </button>{" "}
                    <button type="submit" className="btn btn-primary">
                      Submit
                      <i className="fas fa-sign-in-alt ml-1" />
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <span />
        </div>
      </div>
      <div className="modal-backdrop" role="button" tabIndex={0} aria-label="Close credit modal" onClick={toggleModal} />
    </>
  );
};

export default CreditLimitModal;
